/* SiloreParis — scroll-triggered popup (homepage only) */
(function () {
  'use strict';

  var overlay = document.querySelector('[data-popup]');
  if (!overlay) return;

  var STORAGE_KEY = 'silore_popup_seen';
  var threshold = parseInt(overlay.dataset.scrollPercent, 10) || 70;
  var shown = false;
  var lastFocus = null;

  if (sessionStorage.getItem(STORAGE_KEY)) return;

  function open() {
    if (shown) return;
    shown = true;
    lastFocus = document.activeElement;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    sessionStorage.setItem(STORAGE_KEY, '1');
    var focusable = overlay.querySelector('input, button');
    if (focusable) focusable.focus();
    window.removeEventListener('scroll', onScroll);
    document.addEventListener('keydown', onKey);
  }

  function close() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKey);
    if (lastFocus) lastFocus.focus();
  }

  function onScroll() {
    var scrolled = window.scrollY + window.innerHeight;
    var pct = (scrolled / document.documentElement.scrollHeight) * 100;
    if (pct >= threshold) open();
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      var f = overlay.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  overlay.querySelectorAll('[data-popup-close]').forEach(function (b) {
    b.addEventListener('click', close);
  });
  overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });

  window.addEventListener('scroll', onScroll, { passive: true });
})();
